import { integracaoContabilApi } from '@/api/IntegracaoContabilApi';
import { RelatorioFaturamentoBrutoModel } from "@/models/contabil/faturamento-bruto/RelatorioFaturamentoBrutoModel"

export default class ContabilFaturamentoBrutoService { 

    static gerarRelatorio(relatorio : RelatorioFaturamentoBrutoModel): Promise<any> {

        const requestRelatorioFaturamentoBrutoDTO = {
            inicio: relatorio.inicio,
            fim: relatorio.fim,
            tipoNaturezaServico: relatorio.naturezaServico?.valor,
        }

        return integracaoContabilApi.gerarRelatorioFaturamentoBruto(requestRelatorioFaturamentoBrutoDTO);
    }

    static gerarRelatorioExcel(relatorio : RelatorioFaturamentoBrutoModel): Promise<any> {

        const requestRelatorioFaturamentoBrutoDTO = {
            inicio: relatorio.inicio,
            fim: relatorio.fim,
            tipoNaturezaServico: relatorio.naturezaServico?.valor,
        }

        return integracaoContabilApi.gerarRelatorioFaturamentoBrutoExcel(requestRelatorioFaturamentoBrutoDTO);
    }
}

